import { createApp } from 'vue';
import session_buttons from './components/session-buttons.vue';
import login_modal from './components/login-modal.vue';
import signup_form from './components/signup-form.vue';
import verifyUser from './components/verify-user.vue';
import FrequentlyAskedQuestions from './components/frequently-asked-questions.vue';
import GallerySection from './components/gallery-section.vue';
import WhereBuy from './components/WhereBuy.vue';
import TopProducts from './components/top-products.vue';
import PromotionsSection from './components/promotions-section.vue';
import CompleteRegistration from './components/CompleteRegistration.vue';


const app = createApp({
    components: { 
        'session-buttons': session_buttons,
        'login-modal': login_modal,
        'signup-form': signup_form,
        'verify-user': verifyUser,
        'frequently-asked-questions': FrequentlyAskedQuestions,
        'galery-section': GallerySection,
        'where-buy': WhereBuy,
        'top-products': TopProducts,
        'promotions-section': PromotionsSection,
        'complete-registration': CompleteRegistration
    }
});

app.mount('#app');
